import { typography } from '@synoptic/ui-kit/typography.js';
import { style } from '@vanilla-extract/css';
import { EditorThemeClasses } from 'lexical';
import { baseTextEditorStyles, baseTextEditorTheme } from './base.css';

const bold = style(typography['titleSm']);

export const smallTextEditorTheme = {
  ...baseTextEditorTheme,
  root: style([baseTextEditorStyles.root, typography['bodyMd']]),
  heading: {
    h1: style(typography['titleMd']),
    h2: bold,
    h3: bold,
    h4: bold,
    h5: bold,
    h6: bold,
  },
  list: {
    ...baseTextEditorTheme.list,
    ol: style(baseTextEditorStyles.list.ol),
    ul: style(baseTextEditorStyles.list.ul),
  },
  text: {
    ...baseTextEditorTheme.text,
    bold: bold,
  },
} satisfies EditorThemeClasses;
